import Vue from "vue";

import Upload from "@/components/Upload/Upload";
import Dialog from "@/components/Dialog/Dialog"

import TemplateChoices from "@/views/listGeneral/Template/TemplateChoices";
import TemplateSort from "@/views/listGeneral/Template/TemplateSort";
import TemplateConjugation from "@/views/listGeneral/Template/TemplateConjugation";
import TemplateKanji from "@/views/listGeneral/Template/TemplateKanji";
import TemplateShortSentences from "@/views/listGeneral/Template/TemplateShortSentences";
import TemplateLongSentences from "@/views/listGeneral/Template/TemplateLongSentences";
import TemplateComprehension from "@/views/listGeneral/Template/TemplateComprehension";
import TemplateMultiRead from "@/views/listGeneral/Template/TemplateMultiRead";
import FormChoices from "@/views/listGeneral/Form/FormChoices";
import FormSort from "@/views/listGeneral/Form/FormSort";
import FormConjugation from "@/views/listGeneral/Form/FormConjugation";
import FormKanji from "@/views/listGeneral/Form/FormKanji";
import FormShortSentences from "@/views/listGeneral/Form/FormShortSentences";
import FormLongSentences from "@/views/listGeneral/Form/FormLongSentences";
import FormComprehension from "@/views/listGeneral/Form/FormComprehension";
import FormMultiRead from "@/views/listGeneral/Form/FormMultiRead";

export const FormBuilder = new Vue({
  components: {
    Upload,
    Dialog,
    TemplateChoices,
    TemplateSort,
    TemplateConjugation,
    TemplateKanji,
    TemplateShortSentences,
    TemplateLongSentences,
    TemplateComprehension,
    TemplateMultiRead,
    FormChoices,
    FormSort,
    FormConjugation,
    FormKanji,
    FormShortSentences,
    FormLongSentences,
    FormComprehension,
    FormMultiRead,
  },
});
